export const textureAccessor = (
  numTextures: number,
  functionName = 'sampleTexture',
  samplersName = 'uSamplers',
) => {
  const accessors: string[] = [];
  for (let i = 0; i < numTextures; ++i) {
    accessors.push(
      `if (texID < ${i}.5) return texture2D(${samplersName}[${i}], texCoord);`,
    );
  }
  return `vec4 ${functionName}(vec2 texCoord, float texID) {
    ${accessors.join('\n')}
    return vec4(0, 0, 0, 0);
  }`;
};

export function getTextureUnits() {
  const HardwareAnalytics = require('@play-co/timestep-core/lib/platforms/browser/HardwareAnalytics');
  const { computeVertexTextureUnitsSafely } = HardwareAnalytics;
  return computeVertexTextureUnitsSafely();
}
